<template>
  <div>
    <NavBar />
    <view-error :item="error" @updated="getErrors" @close="error = null" />
    <b-overlay :show="loading" opacity="0.99">
      <b-container>
        <v-card>
          <v-card-title>
            <b-row align-v="center">
              <b-col cols="auto"> ERROS </b-col>
              <b-col>
                <v-text-field
                  class="p-0 m-0"
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                />
              </b-col>
              <b-col cols="auto">
                <v-btn icon @click="getErrors">
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </b-col>
            </b-row>
          </v-card-title>
          <v-card-text>
            <ErrorsMessages :errors="errors" />
            <b-row>
              <b-col>
                <v-data-table
                  :headers="headers"
                  :items="items"
                  dense
                  :server-items-length="count"
                  :options.sync="options"
                  :footer-props="{
                    'items-per-page-options': [10, 15, 20, 25, 50, 100],
                    'items-per-page-text': 'Mostrar',
                  }"
                  :loading="loading"
                  loading-text="Carregando..."
                  no-data-text="Nenhum resultado corresponde aos filtros"
                  no-results-text="Nenhum resultado corresponde aos filtros"
                  @click:row="error = $event"
                  @update:options="getErrors"
                >
                  <template #[`item.when`]="{ item }">
                    {{ new Date(item.when).toLocaleString() }}
                  </template>
                </v-data-table>
              </b-col>
            </b-row>
          </v-card-text>
        </v-card>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import ViewError from "../templates/errors/view-error.vue";
import api from "../services/api";

export default {
  name: "Errors",

  components: {
    NavBar,
    ErrorsMessages,
    ViewError,
  },

  data() {
    return {
      errors: [],

      loading: false,

      search: "",
      headers: [
        { text: "Ocorrência", value: "when" },
        { text: "Mensagem", sortable: false, value: "message" },
      ],
      items: [],
      error: null,

      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["when"],
        sortDesc: [true],
        multiSort: true,
        mustSort: false,
      },
      count: 0,
    };
  },

  created() {
    this.getErrors();
  },

  methods: {
    async getErrors() {
      try {
        this.loading = true;

        let sortings = [];
        for (let i = 0; i < this.options.sortBy.length; i++) {
          let header = this.options.sortBy[i];
          let order = this.options.sortDesc[i] ? "desc" : "asc";
          sortings.push({ header, order });
        }

        sortings = JSON.stringify(sortings);

        let params = {
          table: this.table,
          user_id: this.internal_user_id,
          entity_id: this.internal_entity_id,
          search: this.search,
          page: this.options.page,
          items_per_page: this.options.itemsPerPage,
          sortings,
        };
        let response = await api.get("/admin/errors", { params });
        let { error, errors, items, count } = response.data;

        if (error) {
          this.items = [];
          this.count = 0;
          this.errors = errors;
        } else {
          this.errors = [];
          this.items = items;
          this.count = count;
        }

        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>